import commaUp from '../../../assets/images/solution/insurance/comma-up.png'
import commaDown from '../../../assets/images/solution/insurance/comma-down.png'
import commaUp2 from '../../../assets/images/solution/insurance/comma-dxsj.png'

import styles from './style.module.scss'

function SmartComprehensiveInsurance() {
    return (
        <div className={`solution-introduction-wrapper ${styles['insurance-wrapper']}`}>
            <div className={`banner ${styles['banner']}`}>
                <div className='title'>智慧综保</div>
                <div className='content'>率先打造全国智慧综保区建设试点，成为建设智慧园区的先行者</div>
            </div>
            <div className={`introduction-wrapper ${styles['introduction-wrapper']}`}>
                <p className='title'>方案简介</p>
                <div className={`introduction-title ${styles['introduction-title']}`}>
                    <div>
                        <img src={commaUp} alt="" />
                        <p>智慧综保</p>
                        <p>为落实2023年全国海关工作会议提出的智慧海关建设思路要求，烽火星空以提升智能化硬件为基础、优化信息化平台为抓手，构建以智慧监管为核心的“智慧综保区”解决方案，打造“全链条风险防控，全场景顺势监管，全方位高效服务和全领域运行管理”的综合保税区（以下简称“综保区”）生态体系，强化海关、政府、企业之间的信息共享、协同高效，助推综保区管得住、通得快。</p>
                        <img src={commaDown} alt="" />
                    </div>
                </div>
            </div>
            <div className={`achievement-wrapper ${styles['achievement-wrapper']}`}>
                <p className='title'>典型实践</p>
                <div className={styles['achievement-container']}>
                    <div>
                        <img src={commaUp2} alt="" />
                        <p>智慧综保区</p>
                        <p>烽火星空智慧综保区项目打造了“一池、一中心、一平台”的业务系统，提升通关时效，实现综保区全面数字化监管。</p>
                        <p> 一池——汇聚智能设备采集数据、企业生产运营数据以及海关辅助监管数据等，形成了多渠道、多来源的综保区大数据池，实现区内全流程数字化态势感知；</p>
                        <p>一中心——打造运管中心一体化，依托数字孪生技术对区内车、企、货进行画像，构建跨部门业务风险分析处置体系，实现全局感知、科学指挥、快速反应、联勤联动；</p>
                        <p> 一平台——面向企业提供一站式关企、政企服务平台，建立“海关+政府”协同管理机制，打通地方政府、海关、企业间数据壁垒，强化跨系统、跨层级的事项办理联动，实现对综保区的高效管理。</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SmartComprehensiveInsurance